




































































import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { SportEvent } from "@/models";
import { League } from "@/models";
import AppStatusBadge from "./Status/AppStatusBadge.vue";
import AppRegistrationStatusBadge from "./Status/AppRegistrationStatusBadge.vue";
import AppDateDisplay from "@/components/AppDateDisplay.vue";
import { statusVariantFilter } from "@/filters/status-variant.filter";
import { registrationStatusVariantFilter } from "@/filters/registration-status-variant.filter";
import { createSrcSet } from "@/utils/lazysizes.utils";

@Component({
  name: "AppSportEventListItem",
  components: { AppDateDisplay, AppStatusBadge, AppRegistrationStatusBadge },
  methods: {
    createSrcSet: createSrcSet
  },
  filters: { statusVariantFilter, registrationStatusVariantFilter }
})
export default class AppSportEventListItem extends Vue {
  readonly MAX_LEAGUE_COUNT: number = 2;

  @Prop({ required: true }) sportEvent!: SportEvent;

  get isEventEnded() {
    return this.sportEvent.status.code === "end";
  }
  sortedLeagues() {
    return this.sportEvent.leagues.slice().sort(function(a: League, b: League) {
      return a.league_order > b.league_order ? 1 : -1;
    });
  }
}
